import {
    infobarMessageSMIMECannotEncodeText,
    infobarMessageSMIMECannotEncryptText,
    infobarMessageSMIMECannotSignText,
    infobarMessageSMIMEGenericCannotSendText,
    infobarMessageSMIMEGenericCannotSaveText,
    infobarMessageSMIMECannotReadText,
} from './getSmimeErrorContextStringForInfobar.locstring.json';
import {
    infobarMessageSMIMECannotVerifyText,
    infobarMessageSMIMECannotDecryptText,
} from '../strings.locstring.json';
import loc from 'owa-localize';

import SmimeContext from '../store/schema/SmimeContext';

const getSmimeErrorContextStringForInfobar = (context: SmimeContext): string => {
    switch (context) {
        case SmimeContext.ReadingSignedMessage:
            return loc(infobarMessageSMIMECannotVerifyText);
        case SmimeContext.ReadingEncryptedMessage:
            return loc(infobarMessageSMIMECannotDecryptText);
        case SmimeContext.EncodingMessage:
            return loc(infobarMessageSMIMECannotEncodeText);
        case SmimeContext.EncryptingMessage:
            return loc(infobarMessageSMIMECannotEncryptText);
        case SmimeContext.SigningMessage:
            return loc(infobarMessageSMIMECannotSignText);
        case SmimeContext.GenericSendingMessage:
            return loc(infobarMessageSMIMEGenericCannotSendText);
        case SmimeContext.GenericSavingMessage:
            return loc(infobarMessageSMIMEGenericCannotSaveText);
        default:
            return loc(infobarMessageSMIMECannotReadText);
    }
};

export default getSmimeErrorContextStringForInfobar;
